<template>
  <div class="content download">
    <kindPart
      :columns="columns"
      :items="items"
      :kinds="employees"
      kindSelectTitle="員工"
      kindTitle="下傳列表"
      viewName="downloads"
      idProperty="EmployeeId"
      nameProperty="EmployeeName"
      :noKindFuncBtns="true"
      :hasRemove="true"
      @currentIndexChanged="currentIndexChanged"
      @changeKindId="changeEmployeeId"
      @addApplyKind="addDownload"
      @removeApplyKind="removeDownload"
    ></kindPart>
    <form class="flex-start-start w-100" @submit.prevent="saveDownload">
      <div class="download-details">
        <div class="download-details-top">
          <div class="download-data">
            <div class="block-title">下傳紀錄</div>
            <div class="data-card">
              <div>
                <inputTextPart class="w-100" title="名稱" :isRequired="true"
                  ><input
                    type="text"
                    v-model="download.DownloadName"
                    required
                    :readonly="!isAdd"
                /></inputTextPart>
                <inputTextPart class="w-100" title="備註">
                  <input type="text" v-model="download.Memo" :readonly="!isAdd"
                /></inputTextPart>
                <inputCheckboxPart
                  title="完整下載"
                  nameProperty="IsFullDownload"
                  :hasDisabled="!isAdd"
                  ><input
                    id="IsFullDownload"
                    class="custom-control-input"
                    type="checkbox"
                    v-model="download.IsFullDownload"
                    :disabled="!isAdd"
                /></inputCheckboxPart>
              </div>
            </div>
          </div>
          <div v-if="!isAdd" class="download-terminals">
            <div class="block-title">收銀台</div>
            <div class="terminals-container">
              <div
                v-for="terminal in downloadTerminals"
                :key="terminal.TerminalId"
                class="download-terminal"
                :class="terminal.IsSuccess ? 'has-update-time' : ''"
              >
                <div class="terminal">
                  <div>{{ terminal.TerminalName }}</div>
                  <img
                    :style="terminal.IsSuccess ? '' : 'filter: grayscale(1);'"
                    :src="$img.get('Icon/DownloadTerminalCheck.svg')"
                    alt="DownloadTerminalCheck"
                  />
                </div>
                <div class="update-time-dialog">
                  <span>{{ "下傳時間：" + terminal.UpdateTime }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="download-terminals">
            <div class="flex-start-center">
              <div class="block-title w-auto">收銀台</div>
              <inputCheckboxPart
                title="全選"
                nameProperty="allDownloadTerminals"
                style="font-weight: 400; margin: 24px 0 9px 14px; padding: 0"
                ><input
                  id="allDownloadTerminals"
                  class="custom-control-input"
                  type="checkbox"
                  v-model="allDownloadTerminals"
                  @change="allDownloadTerminalsChange"
              /></inputCheckboxPart>
            </div>
            <div class="terminals-container">
              <div
                v-for="terminal in terminals"
                :key="terminal.TerminalId"
                class="download-terminal"
                @click="clickTerminal(terminal, $event)"
              >
                <div class="terminal" style="padding: 8px 6px 0px">
                  <inputCheckboxPart
                    :title="terminal.TerminalName"
                    :nameProperty="terminal.TerminalId"
                    ><input
                      :id="terminal.TerminalId"
                      class="custom-control-input"
                      type="checkbox"
                      :value="terminal.TerminalId"
                      v-model="addTerminalIds"
                  /></inputCheckboxPart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isAdd" class="download-details-bottom">
          <div class="block-title">下傳項目</div>
          <div class="download-list-container">
            <div
              v-for="det in getVisibleDownloadDets(downloadDets)"
              :key="det.DownloadItemType"
              class="download-det"
            >
              <img
                v-if="getDownloadIcon(det.DownloadItemType)"
                :src="$img.get(getDownloadIcon(det.DownloadItemType).url)"
                :alt="getDownloadIcon(det.DownloadItemType).name"
              />
              <div>{{ det.DownloadItemName }}</div>
            </div>
          </div>
        </div>
        <div v-else class="download-details-bottom">
          <div class="flex-start-center">
            <div class="block-title w-auto">下傳項目</div>
            <inputCheckboxPart
              title="全選"
              nameProperty="allDownloadItems"
              style="font-weight: 400; margin: 24px 0 9px 14px; padding: 0"
              ><input
                id="allDownloadItems"
                class="custom-control-input"
                type="checkbox"
                v-model="allDownloadItems"
                @change="allDownloadItemsChange"
            /></inputCheckboxPart>
          </div>
          <div class="download-list-container">
            <div
              v-for="det in getVisibleDownloadDets(dets)"
              :key="det.DownloadItemId"
              class="download-det cursor-pointer"
              @click="clickDet(det, $event)"
            >
              <img
                v-if="getDownloadIcon(det.DownloadItemType)"
                :src="$img.get(getDownloadIcon(det.DownloadItemType).url)"
                :alt="getDownloadIcon(det.DownloadItemType).name"
              />
              <div>{{ det.DownloadItemName }}</div>
            </div>
          </div>
        </div>
      </div>
      <button
        type="submit"
        class="save-download-btn"
        :class="isAdd ? 'cursor-pointer' : ''"
      >
        <img
          v-if="!isAdd"
          :src="$img.get('Icon/Download_gray.svg')"
          alt="DownloadDisabled"
        />
        <img v-else :src="$img.get('Icon/Download.svg')" alt="Download" />
      </button>
    </form>
  </div>
</template>

<script>
import kindPart from "@/components/parts/kindPart.vue";
import inputTextPart from "@/components/parts/inputs/InputTextPart.vue";
import inputCheckboxPart from "@/components/parts/inputs/InputCheckboxPart.vue";

export default {
  data() {
    return {
      items: [],
      download: {},
      downloadDets: [],
      downloadTerminals: [],
      columns: [
        { name: "DownloadName" },
        { name: "Memo" },
        { name: "CreateTime" },
        { name: "EmployeeName" },
      ],
      employees: [],
      currentEmployeeId: null,
      terminals: [],
      dets: [],
      currentIndex: -1,
      isAdd: false,
      addTerminalIds: [],
      addDownloadItemTypes: [],
      allDownloadTerminals: false,
      allDownloadItems: false,
    };
  },
  components: {
    kindPart,
    inputTextPart,
    inputCheckboxPart,
  },
  computed: {
    isDining() {
      return window.localStorage["isDining"] == "true";
    },
    isIndustryType() {
      return window.localStorage["isIndustryType"] == 1;
    },
  },
  watch: {
    // currentIndex(value) {
    //   console.log(value);
    // },
    addTerminalIds: {
      handler(value) {
        if (value.length == this.terminals.length && value.length > 0) {
          this.allDownloadTerminals = true;
        } else {
          this.allDownloadTerminals = false;
        }
      },
      deep: true,
    },
    addDownloadItemTypes: {
      handler(value) {
        const visibleDets = this.getVisibleDownloadDets(this.dets);
        if (value.length == visibleDets.length && value.length > 0) {
          this.allDownloadItems = true;
        } else {
          this.allDownloadItems = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    allDownloadTerminalsChange() {
      if (this.allDownloadTerminals) {
        this.addTerminalIds = [];
        this.terminals.forEach((terminal) => {
          this.addTerminalIds.push(terminal.TerminalId);
        });
      } else {
        this.addTerminalIds = [];
      }
    },
    allDownloadItemsChange() {
      if (this.allDownloadItems) {
        this.addDownloadItemTypes = [];
        this.getVisibleDownloadDets(this.dets).forEach((det) => {
          this.addDownloadItemTypes.push(det.DownloadItemType);
        });
        const items = document.querySelectorAll(".download-det");
        items.forEach((item) => {
          if (item.classList.contains("active")) return;
          item.classList.add("active");
        });
      } else {
        this.addDownloadItemTypes = [];
        const items = document.querySelectorAll(".download-det");
        items.forEach((item) => {
          item.classList.remove("active");
        });
      }
    },
    clickTerminal(terminal, e) {
      if (
        e.target.tagName == "INPUT" ||
        e.target.tagName == "SPAN" ||
        e.target.tagName == "IMG"
      )
        return;
      if (this.addTerminalIds.includes(terminal.TerminalId)) {
        this.addTerminalIds.splice(
          this.addTerminalIds.indexOf(terminal.TerminalId),
          1
        );
      } else {
        this.addTerminalIds.push(terminal.TerminalId);
      }
    },
    getDownloadIcon(type) {
      return this.$enum.downloadIconType.getByValue(type);
    },
    getVisibleDownloadDets(dets) {
      return dets;
    },
    saveDownload() {
      if (!this.isAdd) return;
      if (this.download.DownloadName == "") {
        this.$func.message({
          type: "alert",
          mainMessage: "請輸入名稱 !",
        });
        return;
      }
      if (this.addTerminalIds.length == 0) {
        this.$func.message({
          type: "alert",
          mainMessage: "請選擇收銀台 !",
        });
        return;
      }
      if (this.isDining || this.isIndustryType == 1) {
        this.download.TableMap = 16;
      }
      if (this.addDownloadItemTypes.length == 0) {
        this.$func.message({
          type: "alert",
          mainMessage: "請選擇下傳項目 !",
        });
        return;
      }
      this.download.EmployeeId = window.localStorage["userId"];
      const vm = this;
      this.$api.downloads
        .save({
          Download: vm.download,
          TerminalIds: vm.addTerminalIds,
          DownloadItemTypes: vm.addDownloadItemTypes,
        })
        .then(() => {
          vm.$func.message({
            type: "success",
            mainMessage: "下傳成功 !",
          });
          vm.isAdd = false;
          vm.getDownloads();
        });
    },
    clickDet(det, e) {
      const div = e.currentTarget;
      div.classList.toggle("active");
      if (this.addDownloadItemTypes.includes(det.DownloadItemType)) {
        this.addDownloadItemTypes.splice(
          this.addDownloadItemTypes.indexOf(det.DownloadItemType),
          1
        );
      } else {
        this.addDownloadItemTypes.push(det.DownloadItemType);
      }
    },
    addDownload() {
      this.download = {};
      this.addTerminalIds = [];
      this.addDownloadItemTypes = [];
      this.allDownloadTerminals = false;
      this.allDownloadItems = false;
      this.isAdd = true;
      this.$api.terminals.getNames().then((data) => {
        this.terminals = data;
      });
      this.$api.downloadDets.getEmpty().then((data) => {
        this.dets = data;
        if (window.localStorage["isERP"] == "true") {
          this.dets.push({
            DownloadItemName: "倉庫",
            DownloadItemType: 15,
          });
        }
        if (
          window.localStorage["productType"] == 2 ||
          window.localStorage["productType"] == 4
        ) {
          this.dets.push({
            DownloadItemName: "功能鍵",
            DownloadItemType: 6,
          });
        }
      });
    },
    removeDownload() {
      this.isAdd = false;
      if (this.currentIndex < 0) {
        this.$func.message({
          type: "alert",
          mainMessage: "請選擇一筆資料 !",
        });
        return;
      }
      // this.$func
      //   .message({
      //     type: "confirm",
      //     mainMessage: `確定刪除${
      //       this.items[this.currentIndex].DownloadName
      //     }嗎 ?`,
      //   })
      //   .then(() => {
      this.$api.downloads
        .remove(this.items[this.currentIndex].DownloadId)
        .then(() => {
          this.isAdd = false;
          this.getDownloads();
        });
      // });
    },
    currentIndexChanged(index) {
      this.currentIndex = index;
      this.isAdd = false;
      this.addTerminalIds = [];
      this.download = this.items[index];
      this.getDownloadList();
    },
    getDownloadList() {
      this.$api.downloads
        .downloadList(this.items[this.currentIndex].DownloadId)
        .then((data) => {
          this.downloadDets = data.DownloadDets;
          this.downloadTerminals = data.DownloadTerminals;
        });
    },
    changeEmployeeId(id) {
      this.currentEmployeeId = id;
      this.getDownloads();
    },
    getDownloads() {
      let dTO = {
        page: 1,
        pagesize: 25,
        isDesc: 0,
      };
      if (this.currentEmployeeId) {
        let ids = [];
        ids.push(this.currentEmployeeId);
        dTO.EmployeeIds = ids;
      }
      this.$api.downloads.getPages(dTO).then((data) => {
        this.items = data.Datas;
      });
    },
  },
  mounted() {
    this.$api.employees.getNames().then((data) => {
      data.splice(0, 0, {
        EmployeeId: null,
        EmployeeName: "全部",
      });
      this.employees = data;
    });
    this.getDownloads();
  },
};
</script>

<style lang="scss" scoped>
.download {
  position: relative;
  padding: 0px 24px;
  .kind-part {
    @media screen and (min-width: 768px) {
      width: 30% !important;
    }
  }
}
.download-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1;
  height: 100%;
}
.download-details-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex: 1;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
}
.download-data {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  padding: 0 10px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}
.data-card {
  flex: 1;
  padding: 10px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.16);
}
.download-terminals {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  padding: 0 10px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
}
.terminals-container {
  flex: 1;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.16);
}
.download-terminal {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  &.has-update-time {
    &:hover {
      .update-time-dialog {
        opacity: 1;
        visibility: visible !important;
      }
    }
  }
  .update-time-dialog {
    position: absolute;
    top: 40px;
    right: 10%;
    padding: 10px 15px;
    font-size: 16px;
    font-weight: 300;
    white-space: nowrap;
    color: white;
    background-color: rgba(17, 17, 17, 0.8);
    border-radius: 8px;
    opacity: 0;
    visibility: hidden !important;
    transition: all 0.3s;
  }
}
.terminal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d1d1;
  border-radius: 8px;
}
.download-details-bottom {
  width: 100%;
  padding: 20px 10px;
}
.download-list-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 10px;
  background-color: rgb(255, 255, 255);
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 5px;
}
.download-det {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 68px;
  margin: 10px;
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  font-size: 14px;
  color: #444444;
  &.active {
    border: 1px solid #82b5d8;
    background-color: #ecf3f8;
    color: #4695c9;
  }
}
.save-download-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
